import { render } from "./product-add-actions.vue?vue&type=template&id=b9087f46"
import script from "./product-add-actions.vue?vue&type=script&lang=js"
export * from "./product-add-actions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__